import React, { Component } from 'react';
//import Banner from "./Banner";
import MainView from "./MainView";
import { inject } from "mobx-react";

@inject("commonStore")
export default class Home extends Component {
  render() {
    return (
      <div>
        <MainView />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Home/index.js